module.exports = __webpack_public_path__ + "media/advantages/advantage-img-3-ae92f3cf.png";